module.exports = __webpack_public_path__ + "static/media/topic-modeling.83c9ad8c.svg";